import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import React from 'react';
import { Layout, RowLg7, WhiteBlock } from 'app/blocks/blocks';
import { Button } from 'app/blocks/buttons/buttons';
import { processing, tryCatch } from 'app/blocks/common/decorators';
import { compose } from 'app/blocks/common/utils';
import withScrollToTop from 'app/blocks/common/withScrollToTop';
import * as middleware from 'app/blocks/middleware/middleware';
import CoverImageWidget from 'app/pages/article/widgets/CoverImageWidget';
import OpenAccessOrderContext from 'app/pages/orders/oa/OpenAccessOrderContext';
import routes from 'app/pages/routes';
import FunderPaidConfirmationMessage from './funder_paid_confirmation_message';
import './index.scss';

@autobind
class OrdersConfirmation extends React.PureComponent {
    static propsTypes = {
        article: PropTypes.shape({}),
        order: PropTypes.shape({}),
    };

    state = { isProcessing: true };

    @tryCatch
    @processing
    async componentDidMount() {
        const { article, order } = this.props;
        const revenueModel = order.journal ? order.journal.revenueModel : 'OO';

        const message = await middleware.onlineopen.getOrderConfirmationMessage(revenueModel);
        const coverWidgetValue = await middleware.onlineopen.getOrderConfirmationCoverWidget(
            article.id,
            article.authors[0].participantId,
        );
        this.setState({ message });
        this.setState({ coverWidgetValue });
    }

    goToArticlePage() {
        const { article, onFinish } = this.props;
        if (onFinish && typeof onFinish === 'function') {
            onFinish(true);
        }
        routes.navigateToUrl(`article/${article.id}`);
    }

    render() {
        const { article, order } = this.props;
        const { isProcessing, message, coverWidgetValue } = this.state;
        return (
            <RowLg7>
                <Layout className="order-confirmation-layout" isLoading={isProcessing}>
                    <WhiteBlock className="page m-btm_md" data-seleniumid="orders-confirmation-html">
                        <div dangerouslySetInnerHTML={{ __html: message }} />
                    </WhiteBlock>

                    {order.woaFunderId && <FunderPaidConfirmationMessage articleId={article.id} />}

                    <div className="clearfix m-btm_md">
                        <Button className="pull-right" onClick={this.goToArticlePage}>
                            Back to Manage this Article
                        </Button>
                    </div>
                    {coverWidgetValue?.coverCharge ? (
                        (!coverWidgetValue?.publishedStatus ||
                            (coverWidgetValue?.publishedStatus &&
                                coverWidgetValue?.publicationStatusCode === 'EARLY_VIEW')) && (
                            <div>
                                <CoverImageWidget />
                            </div>
                        )
                    ) : (
                        <div />
                    )}
                </Layout>
            </RowLg7>
        );
    }
}

export default compose(withScrollToTop, OpenAccessOrderContext.withContext())(OrdersConfirmation);
